$(document).ready(function () {

  $(document).on("click", "[href^='#']", function (e) {
    e.preventDefault();
    var scrollSelector = $(this).attr("href");
    smoothScrollTo(scrollSelector);
  });

  // Smooth scroll handling from a link
  var hash = window.location.hash;
  if (hash) {
    window.location.hash = "";
    smoothScrollTo(hash);
  }
});


function smoothScrollTo(scrollSelector) {
  if (!/^#\w/.test(scrollSelector)) {  // if the # is followed by a selector designation ( not a letter )
    scrollSelector = scrollSelector.replace("#", "");
  }
  var $scrollToElement = $(scrollSelector);
  $navHeight = getNavHeight(); // from navigation.js
  if ($scrollToElement.length) {
    $("html, body").animate({
      scrollTop: $($scrollToElement).offset().top - $navHeight - 20
    }, 1000);
  }
}